import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { useState } from 'react';

export const DisclaimerBanner = ({ variant = 'inline' }) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed && variant === 'dismissible') return null;

  const message = "Las recomendaciones se basan en análisis estadístico y no garantizan resultados. Juegue responsablemente.";

  if (variant === 'fixed') {
    return (
      <div 
        className="fixed bottom-0 left-0 right-0 z-40 bg-amber-900/90 backdrop-blur-sm border-t border-amber-700/50 px-4 py-3"
        data-testid="disclaimer-banner-fixed"
      >
        <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-amber-200">
          <AlertTriangle size={18} className="flex-shrink-0" />
          <p className="text-sm">{message}</p>
        </div>
      </div>
    );
  }

  if (variant === 'dismissible') {
    return (
      <div 
        className="disclaimer-banner flex items-center justify-between gap-4"
        data-testid="disclaimer-banner-dismissible"
      >
        <div className="flex items-center gap-3">
          <AlertTriangle size={18} className="flex-shrink-0 text-amber-400" />
          <p className="text-sm">{message}</p>
        </div>
        <button 
          onClick={() => setDismissed(true)}
          className="text-amber-400 hover:text-amber-300 transition-colors"
          data-testid="dismiss-disclaimer"
        >
          <X size={18} />
        </button>
      </div>
    );
  }

  return (
    <div 
      className="disclaimer-banner flex items-center gap-3"
      data-testid="disclaimer-banner-inline"
    >
      <AlertTriangle size={18} className="flex-shrink-0 text-amber-400" />
      <p className="text-sm">{message}</p>
    </div>
  );
};

export default DisclaimerBanner;
